module.exports = __webpack_public_path__ + "static/img/5.0b8cd9b.png";


//////////////////
// WEBPACK FOOTER
// ./static/pc/5.png
// module id = I2Kd
// module chunks = 0